import useIdleTimer from "@/hooks/useIdleTimer";
import { FC, ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

interface IdleTimerProps {
    children: ReactNode | ReactNode[]
}

const ALLOWED_EVENTS: Array<keyof DocumentEventMap> = [
    'mousemove',
    'keydown',
    'wheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'visibilitychange',
    'focus',
];

const loginRoute = '/auth/login';

const IdleTimer: FC<IdleTimerProps> = ({ children }) => {
    const navigate = useNavigate();
  const location = useLocation();

    const { init, off } = useIdleTimer({
        events: ALLOWED_EVENTS,
        timeout: 1000 * 60 * 45,
        onIdle: onIdleHandle
    });

    function onIdleHandle(){
        toast.error("Su sesión ha expirado por inactividad; inicie sesión nuevamente para continuar utilizando nuestros servicios.", { autoClose: 300000 })
        off();
        navigate(loginRoute);
    }


    useEffect(() => {
        if (loginRoute === location.pathname) return;
        init();
    }, [location]);

    return (<>{children}</>)
}

export default IdleTimer
